import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  APPLY_COUPON: ({ commit, dispatch }, text) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/apply-coupon`, { text: text }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/coupon/actions.js